exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-toggle[data-v-ac49f970] {\n  cursor: pointer;\n}", ""]);

// exports
